import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { RouteAction, RouteSelector } from "@obg/ngx.router";
import { Observable, of } from "rxjs";
import { filter, map, switchMap, take, tap } from "rxjs/operators";

import { CORE_ROUTE } from "../../route";
import { CoreState } from "../../state";
import { AuthenticationStatus } from "../auth.model";
import { AuthSelector } from "../auth.selector";

@Injectable({
	providedIn: "root",
})
export class AuthAnonymousGuard implements CanActivate {
	constructor(private store: Store<CoreState>) {}

	canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
		return this.store.select(AuthSelector.getAuthenticationStatus).pipe(
			filter((status) => status !== AuthenticationStatus.Pending),
			take(1),
			switchMap((status) => {
				if (status === AuthenticationStatus.Authenticated) {
					return this.store.select(RouteSelector.getCurrent).pipe(
						tap((route) => {
							if (route) {
								return;
							}

							this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
						}),
						map(() => false)
					);
				}

				return of(true);
			})
		);
	}
}
